import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import { CONTACT_PERSON_VALIDATION_FIELDS } from "../../../constants";

export const phoneNumberRegex = /^[0-9]{10}$/;
export const telephoneRegex = /^[0-9]+$/;
export const mailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneNumberValidator = (rule, value) => {
  let isValid = true;

  if (value && typeof value == "object" && "value" in value[0]) {
    value.forEach((each_value) => {
      if (each_value.value && !telephoneRegex.test(each_value.value)) {
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      return Promise.reject(new Error("Must be valid phone number with 10 digits."));
    }
  } else {
    if (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !telephoneRegex.test(value)
    ) {
      return Promise.reject(new Error("Must be valid phone number with 10 digits."));
    }
  }

  return Promise.resolve();
};

export const emailValidator = (rule, value) => {
  let isValid = true;

  if (value && typeof value == "object" && "value" in value[0]) {
    value.forEach((each_value) => {
      if (each_value.value && !mailRegex.test(each_value.value)) {
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      return Promise.reject(new Error("Must be valid email address."));
    }
  } else {
    if (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !mailRegex.test(value)
    ) {
      return Promise.reject(new Error("Must be valid email address."));
    }
  }

  return Promise.resolve();
};

export const CINValidator = (rule, value) => {
  const regex =
    /([A-Za-z]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/;
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !value.match(regex)
  ) {
    return Promise.reject(new Error("Must be valid CIN number."));
  }
  return Promise.resolve();
};

export const TANValidator = (rule, value) => {
  const regex = /([A-Za-z]{4})([0-9]{5})([A-Za-z]{1})$/;
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !value.match(regex)
  ) {
    return Promise.reject(new Error("Must be valid TAN number."));
  }
  return Promise.resolve();
};

export const GSTValidator = (rule, value) => {
  const regex =
    /([0-9]{2})([A-Za-z]{5})([0-9]{4})([A-Za-z]{1})([A-Za-z0-9]{3})$/;
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !value.match(regex)
  ) {
    return Promise.reject(new Error("Must be valid GST number."));
  }
  return Promise.resolve();
};

export const AadharValidator = (rule, value) => {
  const regex = /([0-9]{12})$/;
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !value.match(regex)
  ) {
    return Promise.reject(new Error("Must be valid Aadhar number."));
  }
  return Promise.resolve();
};

export const PincodeValidator = (rule, value) => {
  const regex = /([0-9]{6})$/;
  if (value !== undefined && value !== "" && !value.toString().match(regex)) {
    return Promise.reject(new Error("Must be valid pincode."));
  }
  return Promise.resolve();
};

export const PANValidator = (rule, value) => {
  const regex = /[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/;
  if (value !== undefined && value !== "" && !value.toString().match(regex)) {
    return Promise.reject(new Error("Must be valid PAN number."));
  }
  return Promise.resolve();
};

export const AN13ENRValidator = (rule, value) => {
  if (
    value !== undefined &&
    value !== "" &&
    (value > 29999999 || value < 20000000)
  ) {
    return Promise.reject(
      new Error("Employee code must be between 0020000000 and 0029999999.")
    );
  }
  return Promise.resolve();
};

export const telephoneValidator = async (rule, value) => {
  let isValid = true;

  if (value && typeof value == "object" && "value" in value[0]) {
    value.forEach((each_value) => {
      if (each_value.value && !telephoneRegex.test(each_value.value)) {
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      return Promise.reject(new Error("Telephone number must contain all digits."));
    }
  } else {
    if (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !telephoneRegex.test(value)
    ) {
      return Promise.reject(new Error("Telephone number must contain all digits."));
    }
  }
  return Promise.resolve();
};

export const UdyamValidator = (rule, value) => {
  // const regex = /UDYAM([A-Za-z]{2})([0-9]{12})$/;
  const regex = /UDYAM(-){1}([A-Za-z]{2})(-){1}([0-9]{2})(-){1}([0-9]{7})$/;
  if (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    !value.match(regex)
  ) {
    return Promise.reject(new Error("Must be valid Udyam number."));
  }
  return Promise.resolve();
};

/**
 * \x00-\x7F matches a single character in the range between
 * (index 0) and (index 127) (case sensitive)
 */
export const invalidCharacterValidator = (values, formRef) => {
  let isValid = true;
  Object.keys(values).forEach((decorator) => {
    let field = decorator.replace("_", " ").replace("_", " ");
    field = field.charAt(0).toUpperCase() + field.slice(1);

    if (
      typeof values[decorator] === "string" ||
      typeof values[decorator] === "number"
    ) {
      /**
       * \x00-\x7F matches a single character in the range between
       * (index 0) and (index 127) (case sensitive)
       */
      if (!/^[\x00-\x7F]*$/.test(values[decorator])) {
        formRef.current.scrollToField(decorator);
        formRef.current.setFields([
          {
            name: decorator,
            errors: [`Invalid character in ${field}`],
          },
        ]);
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          `Invalid character in ${field}`
        );

        isValid = false;
        return;
      }
    } else if (isValid && Array.isArray(values[decorator])) {
      values[decorator].forEach((each) => {
        if (
          typeof each === "object" &&
          "value" in each &&
          !/^[\x00-\x7F]*$/.test(each.value)
        ) {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            `Invalid character in ${field}`
          );

          isValid = false;
          return;
        }
      });
    }
  });
  return isValid;
};

export const director_details_validator = (values, formRef) => {
  let isValid = true;
  Object.keys(values).map((each_field) => {
    let field = each_field.replace("_", " ").replace("_", " ");
    field = field.charAt(0).toUpperCase() + field.slice(1);

    if (
      values[each_field] === null ||
      (values[each_field] === undefined) | (values[each_field] === "")
    ) {
      formRef.current.setFields([
        {
          name: each_field,
          errors: [`Please Select ${field}`],
        },
      ]);

      isValid = false;
    } else if (
      typeof values[each_field] === "string" &&
      !/^[\x00-\x7F]*$/.test(values[each_field])
    ) {
      formRef.current.setFields([
        {
          name: each_field,
          errors: [`Invalid character in ${field}`],
        },
      ]);

      isValid = false;
    }
  });

  return isValid;
};

export const contact_person_validator = (
  values,
  formRef,
  raiseError = true
) => {
  let isValid = true;
  Object.keys(values).map((each_field) => {
    let field = each_field.replaceAll("_", " ");
    field = field.charAt(0).toUpperCase() + field.slice(1);

    if (CONTACT_PERSON_VALIDATION_FIELDS.includes(each_field)) {
      if (
        values[each_field] === null ||
        (values[each_field] === undefined) | (values[each_field] === "")
      ) {
        if (raiseError) {
          formRef.current.setFields([
            {
              name: each_field,
              errors: [`Please Select ${field}`],
            },
          ]);
        }

        isValid = false;
      } else if (
        typeof values[each_field] === "string" &&
        !/^[\x00-\x7F]*$/.test(values[each_field])
      ) {
        if (raiseError) {
          formRef.current.setFields([
            {
              name: each_field,
              errors: [`Invalid character in ${field}`],
            },
          ]);
        }

        isValid = false;
      }
    }
  });

  return isValid;
};
